import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface LogPanelCta {
  label: string;
  url: string;
}

export interface SourceChunksPanelContent {
  sourceName: string;
  chunks: string[];
}

export type LogPanelView = 'json' | 'sourceChunks';

export interface LogPanelData {
  content: any;
  title?: string;
  description?: string;
  view?: LogPanelView;
  cta?: LogPanelCta;
}

export interface LogPanelState {
  isLogPanelOpen: boolean;
  panelData: LogPanelData | null;
}

const initialState: LogPanelState = {
  isLogPanelOpen: false,
  panelData: null,
};

const LogPanelSlice = createSlice({
  name: 'LogPanel',
  initialState,
  reducers: {
    openLogPanel: (state, action: PayloadAction<LogPanelData>) => {
      state.isLogPanelOpen = true;
      state.panelData = action.payload;
    },
    closeLogPanel: state => {
      state.isLogPanelOpen = false;
      state.panelData = null;
    },
    toggleLogPanel: state => {
      state.isLogPanelOpen = !state.isLogPanelOpen;
      if (!state.isLogPanelOpen) {
        state.panelData = null;
      }
    },
  },
});

export const { openLogPanel, closeLogPanel, toggleLogPanel } =
  LogPanelSlice.actions;

export default LogPanelSlice.reducer;
